module.exports = __webpack_public_path__ + "img/003刘海涛.cd4ca310.png";